import * as React from "react";
import { Link } from "react-ui";

import { errorsFallback, KREC_ERROR_CONVERT } from "../../../../../Engine/Core/ErrorManager/ErrorManager";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { useMetrics } from "../../../../Internals/Metrics/MetricsProviderContext";
import { VIEW_FILE_ERROR } from "../../../../metricsAction";
import { FileError } from "../FileError";
import { extractFileExtension } from "../../../../../Engine/Core/ModalManager/Modals/Utils/Types";

import { Root } from "./ViewFileError.styles";

interface ViewFileErrorProps {
    error?: FileError | undefined;
    path: AbsoluteModelPath;
    onClickRequirements: () => void;
    extentions?: readonly string[];
    fileName?: string;
}

export function ViewFileError(props: ViewFileErrorProps): JSX.Element {
    const track = useMetrics();

    React.useEffect(() => {
        track(VIEW_FILE_ERROR, {
            path: props.path.toLegacyPath(),
            error: typeof props.error === "object" ? props.error.code : props.error,
        });
    }, []);

    const renderError = (error: FileError | undefined, extentions?: readonly string[], fileName?: string) => {
        if (fileName && extentions && !extentions.includes(extractFileExtension(fileName))) {
            return `Неправильный формат файла. Можно загрузить: ${extentions?.join(", ")}`;
        } else if (typeof error !== "object") {
            return error;
        } else if (error.code === KREC_ERROR_CONVERT) {
            return (
                <span>
                    Не удалось привести документ в соответствие{" "}
                    <Link onClick={props.onClickRequirements}>{"требованиям ФНС"}</Link>. Исправьте вручную или
                    загрузите еще раз в течение часа.
                </span>
            );
        } else {
            return errorsFallback[error.code] ?? "";
        }
    };

    return <Root>{renderError(props.error, props.extentions, props.fileName)}</Root>;
}
